import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const ViewIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"></path>
        <path d="M2 12c1.6-4.097 5.336-7 10-7s8.4 2.903 10 7c-1.6 4.097-5.336 7-10 7s-8.4-2.903-10-7"></path>
      </g>
    </svg>
  );
};

export default ViewIcon;
